// helpers


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

if (window.currencySymbolPosition == 'left') {
  Shopify.money_format = window.cartStrings.currencySymbol + " {{amount}}";
} else {
  Shopify.money_format = "{{amount}}" + window.cartStrings.currencySymbol;
}

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// CartManager
class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
          options && typeof options.onSuccess === 'function'
              ? options.onSuccess
              : function () {
              },
      onFailure:
          options && typeof options.onFailure === 'function'
              ? options.onFailure
              : function () {
              },
      always:
          options && typeof options.always === 'function'
              ? options.always
              : function () {
              },
    });
  }

  handleErrors(options) {
    const errorMessage =
        options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
                'To add a new item both properties: ID & QUANTITY are required',
                item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
                'To update an existing item, both properties: KEY & QUANTITY are required',
                item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = { requests_count: requestsCount };
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {
      };
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {
      };
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {
      };

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
        // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
          nextRequest.formData,
          nextRequest.action,
          nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
          `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
        .then(function (response) {
          if (response.ok) return response.json();
          throw Error(response.statusText);
        })
        .then(function (cart) {
          try {
            options.onSuccess();
          } catch (e) {
            console.error(
                'Error executing onSuccess callback from postShopify',
                e,
            );
          }

          return { cart };
        })
        .catch(function (error) {
          self.handleErrors(error);

          try {
            options.onFailure();
          } catch (e) {
            console.error(
                'Error executing onFailure callback from postShopify',
                e,
            );
          }

          return { err: error };
        })
        .finally(function () {
          try {
            options.always();
          } catch (e) {
            console.error('Error executing always callback from postShopify', e);
          }

          // Handle next request if there are any in the queue.
          if (self.requestsQueue.length) {
            const nextRequest = self.requestsQueue.pop();
            return self.postShopify(nextRequest.formData, nextRequest.action);
          }
        });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

// Remove Button
customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();

        this.removeEvent = new Event('remove', { bubbles: true });
        this.addEventListener('click', (event) => {

          event.preventDefault();
          this.dispatchEvent(this.removeEvent);

        });
      }
    },
);

// Cart items
customElements.define(
    'cart-items',
    class CartItems extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartNotification: 'cart-notification',
          variantSelects: 'variant-selects',
        };

        this.selectors = selectors;
        this.cartNotifications = document.querySelectorAll(
            this.selectors.cartNotification,
        );
        this.variantSelects = document.querySelectorAll(
            this.selectors.variantSelects,
        );

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]'),
        ).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0,
        );

        this.debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));

        this.addEventListener('remove', (event) => {

          // === Check if bundle
          const bundleId = event.target.dataset.bundleId;
          if (bundleId !== null && bundleId !== undefined) {

            this.removeBundle(event.target.dataset.index, document.activeElement.getAttribute('name'), bundleId);

          } else {

            this.updateQuantity(
                event.target.dataset.index,
                0,
                document.activeElement.getAttribute('name'),
                (event.target.dataset != null && event.target.dataset.removeGift != null) ? this.removeGift(event) : "",
            );

          }

        });
      }

      getCookie(name) {
        let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
      }
  
      setCookie(name, value, days) {
        let d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      }

      removeGift(event) {

        if (event.target.dataset.removeGift) {

          const giftItemData = JSON.parse(event.target.dataset.removeGift);

          let manuallyRemovedRewards = [];
          let itemIsAlreadyInCookie = false;
          if (this.getCookie('manuallyRemovedRewards') !== null) {
            manuallyRemovedRewards = JSON.parse(this.getCookie('manuallyRemovedRewards'));
          }
          if (manuallyRemovedRewards.length > 0) {
            manuallyRemovedRewards.forEach(manuallyRemovedReward => {
              if (manuallyRemovedReward.id === giftItemData.id) {
                itemIsAlreadyInCookie = true;
              }
            });
          }

          if (!itemIsAlreadyInCookie) {
            manuallyRemovedRewards.push(giftItemData);
            this.setCookie('manuallyRemovedRewards', JSON.stringify(manuallyRemovedRewards), 3);
          }

        }
        
      }

      onChange(event) {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute('name'),
        );
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-state]',
          },
          {
            id: 'drawer-cart-upsell',
            section:
                document.getElementById('drawer-cart-upsell') != null
                    ? document.getElementById('drawer-cart-upsell').dataset.id
                    : null,
            selector: '[data-upsell-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          }
        ];
      }

      updateQuantity(line, quantity, name, callback) {
        this.enableLoading(line);

        localStorage.setItem('productUpdated', true);

        // --- Check if qty up or down
        let is_update_qty_up = false;
        let is_update_qty_down = false;
        let diffUpdateQuantity = 0;
        if (quantity > 0) {
          const currentLineItem = document.getElementById(`CartItem-${line}`);
          if (currentLineItem && currentLineItem.querySelector(`[name="${name}"]`)) {

            const currentLineQtySelect = currentLineItem.querySelector(`[name="${name}"][data-current-qty]`);
            if (currentLineQtySelect) {
              const currentLineQty = parseInt(currentLineQtySelect.getAttribute('data-current-qty'));
              if (quantity > currentLineQty) {
                is_update_qty_up = true;
                diffUpdateQuantity = quantity - currentLineQty;
              } else if (quantity < currentLineQty) {
                is_update_qty_down = true;
                diffUpdateQuantity = currentLineQty - quantity;
              }
            }

          }
        }

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch('/cart/change', { ...fetchConfig(), ...{ body } })
            .then((response) => {
              return response.text();
            })
            .then((state) => {

              //
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartFooter = document.getElementById('main-cart-footer');

              if (cartFooter)
                cartFooter.classList.toggle(
                    'is-empty',
                    parsedState.item_count === 0,
                );

              let cartCount = parsedState.item_count;

              // === Check if product bundle childs
              if (parsedState.items.length > 0) {
                parsedState.items.forEach(item => {
                  if (item.properties && item.properties._is_bundle_child) {
                    const isBundleChild = item.properties._is_bundle_child;
                    if (isBundleChild !== null && isBundleChild !== undefined && isBundleChild === true) {
                      cartCount -= 1;
                    }
                  }
                });
              }

              this.cartNotifications.forEach((section) => {
                section.updateItemsCount(cartCount);
              });

              this.variantSelects.forEach((section) => {
                section.reset();
              });

              this.getSectionsToRender().forEach((section) => {
                if (section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector,
                    );
                  }
                }
              });

              const lineItem = document.getElementById(`CartItem-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {

                lineItem.querySelector(`[name="${name}"]`).focus();

              }

              this.disableLoading(line);

              if (callback && typeof callback == 'function') {
                callback();
              }

            })
            .catch(() => {
              this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                  overlay.classList.add('hidden'),
              );
              this.disableLoading(line);
            });
      }

      async removeBundle(line, name, bundleId) {

        let bundleItemsToRemove = {};
        const shopifyCart = await cartManager.getCart();

        if (shopifyCart.items.length > 0) {
          shopifyCart.items.forEach(item => {
            if (item.properties && item.properties._bundle_id) {
              const itemBundleIdString = item.properties._bundle_id.toString();
              if (itemBundleIdString === bundleId) {
                bundleItemsToRemove[item.id] = 0;
              }
            }
          });
        }

        if (Object.keys(bundleItemsToRemove).length) {

          this.enableLoading(line);

          localStorage.setItem('productUpdated', true);

          const body = JSON.stringify({
            updates: bundleItemsToRemove,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          });

          fetch('/cart/update', { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {

                //
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter)
                  cartFooter.classList.toggle(
                      'is-empty',
                      parsedState.item_count === 0,
                  );

                let cartCount = parsedState.item_count;

                // === Check if product bundle childs
                if (parsedState.items.length > 0) {
                  parsedState.items.forEach(item => {
                    if (item.properties && item.properties._is_bundle_child) {
                      const isBundleChild = item.properties._is_bundle_child;
                      if (isBundleChild !== null && isBundleChild !== undefined && isBundleChild === true) {
                        cartCount -= 1;
                      }
                    }
                  });
                }

                this.cartNotifications.forEach((section) => {
                  section.updateItemsCount(cartCount);
                });

                this.variantSelects.forEach((section) => {
                  section.reset();
                });

                this.getSectionsToRender().forEach((section) => {
                  if (section.section != null) {
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);
                    if (elementToReplace != null) {
                      elementToReplace.innerHTML = this.getSectionInnerHTML(
                          parsedState.sections[section.section],
                          section.selector,
                      );
                    }
                  }
                });

                const lineItem = document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`))
                  lineItem.querySelector(`[name="${name}"]`).focus();
                this.disableLoading(line);

                if (callback && typeof callback == 'function') {
                  callback();
                }

              })
              .catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) =>
                    overlay.classList.add('hidden'),
                );
                this.disableLoading(line);
              });

        }

      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      enableLoading(line) {
        document
            .getElementById('main-cart-items')
            .classList.add('cart__items--disabled');
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
            (overlay) => overlay.classList.remove('hidden'),
        );
        this.querySelector(`#CartItem-${line}`).classList.add('updating');
        document.activeElement.blur();
      }

      disableLoading(line) {
        document
            .getElementById('main-cart-items')
            .classList.remove('cart__items--disabled');
        if (this.querySelector(`#CartItem-${line}`) != null) {
          this.querySelector(`#CartItem-${line}`).classList.remove('updating');
        }
      }
    },
);

// Quantity input
customElements.define(
    'cart-quantity-input',
    class CartQuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });

        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this)),
        );
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus'
            ? this.input.stepUp()
            : this.input.stepDown();
        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);
      }
    },
);

// Quantity select
customElements.define(
    'cart-quantity-select',
    class CartQuantitySelect extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('select');
        this.changeEvent = new Event('change', { bubbles: true });

        if (this.select !== null && this.select !== undefined) {
          this.currentValue = this.select.value;
          this.select.addEventListener('change', this.onButtonClick.bind(this));
        }
      }

      onButtonClick(event) {
        event.preventDefault();

        if (this.currentValue !== this.select.value) {
          this.currentValue = this.select.value
          this.select.dispatchEvent(this.changeEvent);
        }
      }
    },
);

// Checkout button
customElements.define(
    'cart-checkout-button',
    class cartCheckoutButton extends HTMLElement {
      constructor() {
        super();
        this.changeEvent = new Event('change', { bubbles: true });
        this.checkoutBtns = this.querySelectorAll('[data-checkout-cart-drawer]');

        this.querySelectorAll('[data-checkout-cart-drawer]').forEach((button) =>
            button.addEventListener('click', this.redirectToCheckout.bind(this)),
        );
      }

      redirectToCheckout() {

        window.location = Shopify.routes.root + "checkout";

      }
    },
);

// Cart notification
customElements.define(
    'cart-notification',
    class CartNotification extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartCount: '[data-cart-count]',
        };
        this.selectors = selectors;
        this.cartCount = this.querySelector(this.selectors.cartCount);
      }

      updateItemsCount(itemsCount) {
        if (!this.cartCount) return;

        this.cartCount.innerHTML = itemsCount;

        if (itemsCount < 1) {
          this.classList.add('hidden');
        } else {
          this.classList.remove('hidden');
        }
      }

      getItemsCount() {
        if (!this.cartCount) return;
        return this.cartCount.innerHTML;
      }
    },
);

// Cart Drawer
customElements.define(
    'cart-drawer-z',
    class CartDrawer extends HTMLElement {
      constructor() {
        super();

        const selectors = {
          cartOpen: '[data-cart-drawer-open]',
          cartClose: '[data-cart-drawer-close]',
          cartDrawer: 'cart-drawer-v2',
          cartOverlay: 'cart-overlay',
          cartNotification: 'cart-notification',
          cartUpsellDynamic: 'cart-upsell-dynamic',
        };

        this.selectors = selectors;
        this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
				this.sectionId = this.cartDrawer.dataset.sectionId;
        this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
        this.cartNotifications = document.querySelectorAll(
            this.selectors.cartNotification,
        );
        this.cartUpsellDynamic = document.querySelector(
            this.selectors.cartUpsellDynamic,
        );
				this.footerCart = document.querySelector('.cart-drawer_blocks-bottom');

        this.cartDrawer?.addEventListener(
            'keyup',
            (evt) => evt.code === 'Escape' && this.close(),
        );

        document
            .querySelectorAll(this.selectors.cartOpen)
            .forEach((cartOpen) =>
                cartOpen.addEventListener('click', () => {
                  this.open();
                }, false),
            );

        this.initCloseButtons();

        this.init();
      }

      init() {
        // Detect cart interactions
        this.httpInterceptor(
            [
              '/cart/add.js',
              '/cart/add',
              '/cart/change',
              '/cart/update',
              '/cart/clear',
            ],
            this.handleCartUpdates.bind(this),
        );
      }

      open() {

        this.cartDrawer.classList.add('animate', 'active');
        this.cartOverlay.classList.add('animate', 'active');
        document.querySelector('body').style.overflow = 'hidden';
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
      }

      close() {
        this.cartDrawer.classList.remove('active');
        this.cartOverlay.classList.remove('active');
        document.querySelector('body').style.overflow = 'auto';
        document.removeEventListener('touchmove', this.preventScroll, { passive: false });

        if (window.location.href.indexOf('/cart') > -1) {
          window.location.href = "/"
        }
      }

      initCloseButtons() {
        if (!this._closeListenerAdded) {
          document.addEventListener('click', (e) => {
            const closeButton = e.target.closest(this.selectors.cartClose);
            if (closeButton) {
              if (closeButton.tagName === 'BUTTON' || closeButton.tagName === 'DIV') {
                e.preventDefault();
              }
              e.stopPropagation();
              this.close();
            }
          });
          this._closeListenerAdded = true;
        }
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items') != null
                ? document.getElementById('main-cart-items').dataset.id
                : null,
            selector: '[data-items-cart]',
          },
          {
            id: 'cart-drawer-reward',
            section: document.getElementById('cart-drawer-reward') != null
                ? document.getElementById('cart-drawer-reward').dataset.id
                : null,
            selector: '[data-cart-drawer-reward]',
          },
          {
            id: 'cart-drawer-samples',
            section: document.getElementById('cart-drawer-samples') != null
                ? document.getElementById('cart-drawer-samples').dataset.id
                : null,
            selector: '[data-cart-drawer-samples]',
          },
          {
            id: 'main-cart-summary',
            section: document.getElementById('main-cart-summary') != null
                ? document.getElementById('main-cart-summary').dataset.id
                : null,
            selector: '.cart-drawer-summary',
          },
          {
            id: 'drawer-cart-footer',
            section: document.getElementById('drawer-cart-footer') != null
                ? document.getElementById('drawer-cart-footer').dataset.id
                : null,
            selector: '[data-cart-state]',
          },
          {
            id: 'drawer-cart-upsell-dynamic',
            section:
                document.getElementById('drawer-cart-upsell-dynamic') != null
                    ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
                    : null,
            selector: '[data-upsell-dynamic-cart-drawer]',
          },
          {
            id: 'drawer-cart-upsell',
            section:
                document.getElementById('drawer-cart-upsell') != null
                    ? document.getElementById('drawer-cart-upsell').dataset.id
                    : null,
            selector: '[data-upsell-cart-drawer]',
          }
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
      }

      async renderContents(refreshContentsAllow) {
        await fetch(`${Shopify.routes.root}?sections=${this.sectionId}`, {
          method: 'GET',
        })
            .then((response) => response.json())
            .then((response) => {
              // const doc = new DOMParser().parseFromString(
              //   response['cart-drawer-v2'],
              //   'text/html',
              // );
              // var contentUpdated = doc.querySelector('#cart-drawer-v2').innerHTML;
              // this.cartDrawer.innerHTML = contentUpdated;

              this.getSectionsToRender().forEach((section) => {
                if (section.section != null) {
                  const elementToReplace =
                      document
                          .getElementById(section.id)
                          .querySelector(section.selector) ||
                      document.getElementById(section.id);
                  if (elementToReplace != null) {
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        response[this.sectionId],
                        section.selector,
                    );
                  }
                }
              });

              this.initCloseButtons();

              this.cartProgressBarRewards = document.querySelector('#cart-progressbar-rewards');
              if (this.cartProgressBarRewards !== null && this.cartProgressBarRewards !== undefined && typeof this.cartProgressBarRewards.init === 'function') {
                this.cartProgressBarRewards.init();
              }

              this.cartShippingEstimate = document.querySelector('#cart-drawer-shipping-estimate');
              if (this.cartShippingEstimate !== null && this.cartShippingEstimate !== undefined && typeof this.cartShippingEstimate.init === 'function') {
                this.cartShippingEstimate.init();
              }

            })
            .catch((error) => {
              console.error('Error:', error);
            });

        // L'ouverture du cart est maintenant gérée dans handleCartUpdates
        this.initCheckoutButton();
      }

      initCheckoutButton() {
        var checkoutButton = this.cartDrawer.querySelector('[data-checkout-cart-drawer]');
        if (checkoutButton) {
          checkoutButton.addEventListener('click', function (e) {
            window.location = Shopify.routes.root + "checkout";
          });
        }
      }

      async handleCartUpdates(res, url) {


        const EVENTS = {
          CART_UPDATE: "cart:update",
          CART_UPDATE_ADD: "cart:update:add",
          CART_UPDATE_CLEAR: "cart:update:clear",
          CART_UPDATE_MODIFY: "cart:update:update_content",
        }

        if (res != undefined && res.target != undefined && res.target) {
          res.preventDefault();
        }
        const shopifyCart = await cartManager.getCart();

        let cartCount = shopifyCart.item_count;

        // === Check if product bundle childs
        if (shopifyCart.items.length > 0) {
          shopifyCart.items.forEach(item => {
            if (item.properties && item.properties._is_bundle_child) {
              const isBundleChild = item.properties._is_bundle_child;
              if (isBundleChild !== null && isBundleChild !== undefined && isBundleChild === true) {
                cartCount -= 1;
              }
            }
          });
        }

        this.cartNotifications.forEach((section) => {
          section.updateItemsCount(cartCount);
        });

        if (shopifyCart.item_count == 0) {
          this.classList.add('cart-empty');
        } else {
          this.classList.remove('cart-empty');
        }

        let refreshContentsAllow = true;

        if (localStorage.getItem('noteUpdated')) {
          localStorage.removeItem('noteUpdated');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('productUpdated')) {
          localStorage.removeItem('productUpdated');
          refreshContentsAllow = true;
        }
        if (localStorage.getItem('upsellAdded')) {
          localStorage.removeItem('upsellAdded');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('rewardAdded')) {
          localStorage.removeItem('rewardAdded');
          refreshContentsAllow = false;
        }
        if (localStorage.getItem('samplesAdded')) {
          localStorage.removeItem('samplesAdded');
          refreshContentsAllow = false;
        }

        if (refreshContentsAllow) {
          await this.renderContents(refreshContentsAllow);
          // Ouvrir le cart seulement si c'est un ajout de produit (add.js)
          const shouldOpenCart = url && url.includes('/cart/add');
          if (shouldOpenCart) {
            this.open();
          }
        }

        /* EVENTS */
        /***********************/
        if (url && typeof url === 'string') {
          var requestVerb = (new URL(url)).pathname.replace(/(\/cart\/)([\D]*)(\.js)?/, function (match, p1, p2, p3) {
            return p2;
          });

          const updateEvent = new CustomEvent(EVENTS.CART_UPDATE, {
            // Get the type of the request.
            response: res,
            request: requestVerb,
            items_count: shopifyCart.item_count,
            cart: shopifyCart
          });

          document.body.dispatchEvent(updateEvent);

          var updateEventName = false;

          if (requestVerb.includes('add'))
            updateEventName = EVENTS.CART_UPDATE_ADD;
          if (requestVerb.includes('update'))
            updateEventName = EVENTS.CART_UPDATE_MODIFY;
          if (requestVerb.includes('clear'))
            updateEventName = EVENTS.CART_UPDATE_CLEAR;

          if (updateEventName) {

            const updateEvent2 = new CustomEvent(updateEventName, {
              // Get the type of the request.
              response: res,
              request: requestVerb,
              items_count: shopifyCart.item_count,
              cart: shopifyCart
            });

            document.body.dispatchEvent(updateEvent2);
          }
        }

      }

      async httpInterceptor(urlmatchs, callback) {
        var responseMatchesAnyUrl = function (requestUrl, urls) {
          if (!Array.isArray(urls)) urls = [urls];

          for (const url of urls) {
            if (!requestUrl.includes(url)) continue;
            return true;
          }

          return false;
        };

        // Intercept fetch.
        const constantMock = window.fetch;
        window.fetch = function () {
          return new Promise((resolve, reject) => {
            constantMock
                .apply(this, arguments)
                .then(async (response) => {
                  try {
                    if (
                        responseMatchesAnyUrl(response.url, urlmatchs) &&
                        response.type != 'cors' &&
                        response.ok
                    ) {
                      let json = await response.clone().json();
                      if (typeof callback === 'function')
                        await callback(json, response.url);
                    }
                  } catch (err) {
                    console.error(
                        'Something went wrong while intercepting cart update',
                        err,
                    );
                  }
                  resolve(response);
                })
                .catch((error) => {
                  reject(error);
                });
          });
        };

        // Intercept Ajax.
        let send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
          this.addEventListener(
              'readystatechange',
              async function () {
                if (
                    responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
                    this.readyState === 4 &&
                    this.status == 200
                ) {
                  if (typeof callback === 'function')
                    await callback(JSON.parse(this.response), this.responseURL);
                }
              },
              false,
          );
          send.apply(this, arguments);
        };

        // TODO: Listen to HTML form submits.
        // Intercept HTML Forms.
        // document.addEventListener(
        //   'submit',
        //   function (e) {
        //     // Valid the target.
        //     if (
        //       !e.target ||
        //       e.target.tagName.toLowerCase() !== 'form' ||
        //       e.target.matches('[sz-no-block]')
        //     )
        //       return;
        //     // Validate the URL.
        //     var form = e.target;
        //     var submitButton = e.submitter;
        //     var actionUrl = new URL(form.action);
        //     var actionPath = actionUrl.pathname;
        //     if (!actionPath.includes('/cart')) return;
        //     if (form.classList.contains('cart-add-product')) return;

        //     var isUpsell = false;
        //     if (submitButton.classList.contains('product-card-upsell_button')) {
        //       isUpsell = true;
        //     }

        //     e.preventDefault();

        //     const config = fetchConfig('javascript');
        //     config.headers['X-Requested-With'] = 'XMLHttpRequest';
        //     delete config.headers['Content-Type'];

        //     const formData = new FormData(form);
        //     config.body = formData;


        //     // Close quickadd popup
        //     var quickAdd = document.querySelector("[data-quickadd-popup]");
        //     if (quickAdd != undefined) quickAdd.style.display = "none";

        //     fetch(actionPath, config)
        //       .then((response) => response.json())
        //       .then(async function (response) {
        //         if (response.status) {
        //           return;
        //         }


        //         if (actionPath == "/cart/add") {

        //         }

        //         if (typeof callback === 'function')
        //           await callback(undefined, response);
        //       })
        //       .catch((e) => {
        //         console.error(e);
        //       })
        //       .finally(() => {});
        //   }.bind(this),
        // );
      }
    },
);
